module.exports = __webpack_public_path__ + "media/images/icon__plus-9a76eb93d04cd8be9e984d076735b869.png";